import { Component } from '@angular/core';

import { TranslatePipe } from '../../../../pipes/translate.pipe';

@Component({
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: 'datatable-progress',
  template: `
    <div class="progress-linear"
         role="progressbar"
         aria-live="polite"
         aria-label="progress bar"
         [attr.aria-valuenow]="0"
         [attr.aria-valuemin]="0"
         [attr.aria-valuemax]="100"
         [attr.aria-valuetext]="'tdWb.loading.LOADING' | tdWbTranslate">
      <div class="container">
        <div class="bar"></div>
      </div>
    </div>
  `,
  imports: [
    TranslatePipe
  ]
})
export class ProgressBarComponent {}
